import script from "./RelatosList.vue?vue&type=script&setup=true&lang=js"
export * from "./RelatosList.vue?vue&type=script&setup=true&lang=js"

import "./RelatosList.vue?vue&type=style&index=0&id=c2fa3598&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2fa3598"]])

export default __exports__